import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, Drawer, message, Col, Row, DatePicker } from 'antd';
import { postApiWithAuthToken, getApiWithAuthToken, getApiWithPublicAuthToken, updateApiWithAuthToken } from '../../../api';

const ProductCategoryForm = ({ handleDrawerClose, isDrawerVisible, getProductCategoryList, productCategory }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
    }, [productCategory]);

    // Form Submit 

    const handleSubmit = () => {
        form.submit();
    };

    const onFinish = (values) => {
        message.loading({ content: 'Processing...', key: 'form' });

        if (productCategory.id) {
            updateApiWithAuthToken(`/api/v1/admin/productCategories/${productCategory.id}`, values).then((res) => {
                if (!res.error) {
                    setTimeout(() => {
                        message.success({ content: res.msg, key: 'form' });
                    }, 500);
                    handleDrawerClose();
                    getProductCategoryList();
                } else {
                    setTimeout(() => {
                        if (res.errors.length) {
                            res.errors.map((each) => {
                                message.error({ content: each.msg, key: 'form' });
                                return null;
                            });
                        } else {
                            message.error({ content: res.errors, key: 'form' });
                        }
                    }, 500);
                }
            });
        } else {
            postApiWithAuthToken('/api/v1/admin/productCategories', values).then((res) => {
                if (!res.error) {
                    setTimeout(() => {
                        message.success({ content: res.msg, key: 'form' });
                    }, 500);
                    handleDrawerClose();
                    getProductCategoryList();
                } else {
                    setTimeout(() => {
                        if (res.errors.length) {
                            res.errors.map((each) => {
                                message.error({ content: each.msg, key: 'form' });
                                return null;
                            });
                        } else {
                            message.error({ content: res.errors, key: 'form' });
                        }
                    }, 500);
                }
            });
        }
    };

    return (
        <Drawer
            title={productCategory.id ? "Edit product category" : "Add product category"}
            width={480}
            onClose={handleDrawerClose}
            visible={isDrawerVisible}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
                <div style={{ textAlign: 'right', }}>
                    <Button onClick={handleDrawerClose} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} type="primary">
                        Submit
                    </Button>
                </div>
            }
        >
            <Form layout="vertical"
                hideRequiredMark
                form={form}
                initialValues={{ remember: true }}
                onFinish={onFinish} >
                <Form.Item
                    name="name"
                    label="Name"
                    initialValue={productCategory.name}
                    rules={[{ required: true, message: 'This field is required' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="ref_code"
                    label="Ref Code"
                    initialValue={productCategory.ref_code}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Drawer >
    );
};
export default ProductCategoryForm;
